var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2168 0.253513C13.1322 0.173183 13.0316 0.109424 12.9208 0.0659125C12.8099 0.0224015 12.691 0 12.5709 0C12.4508 0 12.3319 0.0224015 12.2211 0.0659125C12.1102 0.109424 12.0096 0.173183 11.925 0.253513L7.75863 4.17878C7.67406 4.25911 7.57344 4.32287 7.46259 4.36638C7.35173 4.40989 7.23283 4.43229 7.11274 4.43229C6.99265 4.43229 6.87375 4.40989 6.76289 4.36638C6.65204 4.32287 6.55142 4.25911 6.46686 4.17878L2.30044 0.253513C2.21588 0.173183 2.11526 0.109424 2.00441 0.0659125C1.89355 0.0224015 1.77465 0 1.65456 0C1.53447 0 1.41557 0.0224015 1.30471 0.0659125C1.19386 0.109424 1.09324 0.173183 1.00867 0.253513C0.839242 0.414091 0.744141 0.631311 0.744141 0.85773C0.744141 1.08415 0.839242 1.30137 1.00867 1.46195L5.18418 5.39579C5.69589 5.87728 6.38953 6.14773 7.11274 6.14773C7.83595 6.14773 8.52959 5.87728 9.0413 5.39579L13.2168 1.46195C13.3862 1.30137 13.4813 1.08415 13.4813 0.85773C13.4813 0.631311 13.3862 0.414091 13.2168 0.253513Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBottom);
export default __webpack_public_path__ + "static/media/chevron_bottom.2865b48457b6d0945bc7b10778cf7264.svg";
export { ForwardRef as ReactComponent };